module.exports = __webpack_public_path__ + "img/point-map-color.36142adb.png";